<template>
  <div class="wrap1">
    <h2 class="common-title">
      <span>{{ $t('payroll_wage_12') }}</span>
      <div class="btn">
        <el-button size="small" @click="handleExport" v-if="$p('menu.payroll.wage.export')">{{ $t('518') }}</el-button>
      </div>
    </h2>
    <div class="wrap1-box">
      <el-table ref="Eltable" v-load="loading" :data="tableData" max-height="550">
        <el-table-column
          v-for="(label, prop) in columns"
          :key="prop"
          :prop="prop"
          :label="label"
          min-width="150px"
        ></el-table-column>
      </el-table>
      <div class="pagination" v-if="!this.params.is_combine">
        <el-pagination
          :page-sizes="[20, 60, 80, 100]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          :current-page.sync="page.page"
          :page-size.sync="page.page_size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <ExportExcelDialog ref="ExportExcelDialog" />
  </div>
</template>

<script>
import ExportExcelDialog from '_c/ExportExcelDialog'

export default {
  components: {
    [ExportExcelDialog.name]: ExportExcelDialog
  },
  data() {
    return {
      params: JSON.parse(sessionStorage.getItem('payroll.wage.list.params')),
      columns: {},
      tableData: [],
      loading: false,
      page: {
        total: 0,
        page: 1,
        page_size: 20
      }
    }
  },
  created() {
    // sessionStorage.removeItem('payroll.wage.list.params')
    // if (!this.params) {
    //   this.$router.push('/payroll/wage')
    //   return
    // }
    this.loading = true
    // 获取导出的全量数据
    Promise.all([this.getColumns(), this.getTableData()])
      .then(res => {
        const [res1, res2] = res
        this.columns = res1.data
        this.tableData = res2.data.list
        this.page.total = res2.data.count
        this.$nextTick(() => {
          this.$refs.Eltable.doLayout()
        })
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    /**
     * 获取表格列
     */
    getColumns() {
      return this.$http({
        url: '/web/payroll_sub_project_staff/getPaySheetCombinedHeader',
        data: {
          is_combine: this.params.is_combine,
          sub_project_id: this.params.sub_project_id
        }
      })
    },
    /**
     * 获取表格数据
     */
    getTableData() {
      return this.$http({
        url: '/web/payroll_sub_project_staff/getPaySheetCombinedList',
        data: {
          is_combine: this.params.is_combine,
          sub_project_id: this.params.sub_project_id,
          page: this.page.page,
          page_size: this.page.page_size
        }
      })
    },
    /**
     * 刷新表格数据
     */
    reloadTableData() {
      this.loading = true
      this.getTableData()
        .then(res => {
          this.tableData = res.data.list
          this.page.total = res.data.count
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 导出事件
     */
    handleExport() {
      const { relation_type, relation_id, sub_project_id, is_combine } = this.params
      const params = {
        relation_type,
        relation_id
      }
      const data = { sub_project_id, is_combine }
      this.$refs.ExportExcelDialog.init(params, data)
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange() {
      this.reloadTableData()
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange() {
      this.reloadTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.common-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  .con {
    flex: 1;
  }
}

.pagination {
  text-align: right;
}
</style>
